import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren
} from "@angular/core";
// import { OfferItemComponent } from "../../components/offer-item/offer-item.component";
// import { ActivatedRoute, ParamMap } from "@angular/router";
// import { ApiService } from "~/app/core/api.service";
// import { NavigationService } from "~/app/core/navigation.service";
// import * as Log from "~/app/core/log";
// import { Level } from "~/app/core/log";
import { BasePage } from "~/app/pages/base.page";
// import { SponsorInfo } from "~/app/core/model/sponsor-info";
// import { OfferListComponent, OfferShowAction } from "~/app/components/offer-list/offer-list.component";
// import { InteractionType } from "~/app/core/model/interaction-type";
// import { InteractionComponent } from "~/app/core/model/interaction-component";
// import { InteractionRefType } from "~/app/core/model/interaction-ref-type";
// import { OfferInfo } from "~/app/core/model/offer-info";
// import { Subscription } from "rxjs";
// import * as _ from "lodash";
// import { momentNow, toDateStr } from "~/app/core/model/date-str";
// import { NotificationService } from "~/app/core/notification.service";
// import { OfferFilter } from "~/app/core/model/offer-filter";
// import { deepEquals } from "~/app/core/util/string-util";
// import { TicketService } from "~/app/core/model/ticket-service/ticket.service";
// import { SuspendService } from "~/app/core/suspend.service";

@Component({
    selector: "Offers",
    templateUrl: "./offers.page.html",
    styleUrls: ["./offers.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OffersPage extends BasePage {
// export class OffersPage extends BasePage implements OnInit, AfterViewInit, OnDestroy {
    // @ViewChildren("freeList") readonly freeList: QueryList<OfferListComponent>;
    // @ViewChildren("couponList") readonly couponList: QueryList<OfferListComponent>;
    // // @ViewChildren("offerMap") readonly offerMap: QueryList<OfferMapComponent>;
    // @ViewChildren("couponList") readonly offerMap: QueryList<OfferListComponent>;
    //
    // freeOffers: Array<OfferInfo> = [];
    // couponOffers: Array<OfferInfo> = [];
    // numFavorites: number = 0;
    // filter: OfferFilter = {};
    // allOffers: Array<OfferInfo> = [];
    // mapOffers: Array<OfferInfo> = [];
    //
    // sponsor: SponsorInfo = null;
    // initTabId: string = null;
    // allowFiltering: boolean = false;
    //
    // get selectedNavId(): string {
    //     return this.getSelectedNavId(this.selectedNav);
    // }
    //
    // get offersFoundCount() : number {
    //     return this.allOffers.length;
    // }
    //
    // get isActiveSearch(): boolean {
    //     if (!this.filter) return false;
    //     if (this.filter.freeForm) return true;
    //     if (this.filter.tags && this.filter.tags.length > 0) return true;
    //     if (this.filter.excludeLocal) return true;
    //     if (this.filter.excludeOnline) return true;
    //     return false;
    // }
    //
    // private ready: boolean = false;
    // private readySubscription: Subscription = null;
    // private initOfferId: number = null;
    // private initAutoOpen: boolean = null;
    //
    // private changedSelection: boolean = false;
    // private selectedFree: number = 0;
    // private selectedCoupon: number = 0;
    // private selectedNav: number = 0;
    // private ticketsSubscription;
    // private nextSearchDate: moment.Moment;
    // private resumeSubscription: Subscription;
    //
    // constructor(
    //     private readonly cd: ChangeDetectorRef,
    //     private readonly activatedRoute: ActivatedRoute,
    //     private readonly nav: NavigationService,
    //     private readonly notify: NotificationService,
    //     private readonly tickets: TicketService,
    //     private readonly suspend: SuspendService,
    //     private readonly api: ApiService
    // ) {
    //     super();
    //     // register
    //     this.notify.registerPushNotifications();
    //     this.ticketsSubscription = this.tickets.ticketDiffObservable().subscribe((diff) => {
    //         this.cd.markForCheck();
    //     });
    //
    //     this.nextSearchDate = momentNow().endOf("day").add(4, "hours");
    //     this.resumeSubscription = this.suspend.statusObservable().subscribe((status) => {
    //         if (status === "resume") {
    //             if (this.nextSearchDate.isBefore(momentNow())) {
    //                 // need to search again because it's a new day
    //                 this.nav.navPageSearching(this.api);
    //             }
    //         }
    //     });
    // }
    //
    // ngOnInit(): void {
    //     if (this.settings.gamificationEnabled) {
    //         setTimeout(() => {
    //             this.api.tickets_fetchTickets().then(() => {
    //                 this.api.tickets_openedApp().then(() => {
    //                     // if (this.api.tickets_referralEligible()) {
    //                     if (this.api.tickets_referralEligible() && !this.api.tickets_referralNotified()) {
    //                         this.api.tickets_notifyReferral();
    //                     }
    //                 });
    //             });
    //         }, 1000);
    //     }
    //
    //     this.sponsor = this.api.offers_loadSponsor();
    //     this.loadOffers();
    //
    //     // Init your component properties here.
    //     this.activatedRoute.queryParamMap.subscribe((value: ParamMap) => {
    //         this.initOfferId = null;
    //         this.initAutoOpen = false;
    //         Log.debug(Log.Tag.OffersPage, "params: " + JSON.stringify(value));
    //         if (value.has("offerId")) {
    //             this.initOfferId = Number(value.get("offerId"));
    //             this.initTabId = this.freeOffers.length > 0 && this.freeOffers[0].id > 0 ? "free" : (this.couponOffers.length > 0 ? "discount" : null);
    //             this.initAutoOpen = true;
    //             if (value.has("autoOpen")) {
    //                 this.initAutoOpen = value.get("autoOpen") === "true";
    //             }
    //             if (this.freeOffers.findIndex((offer) => this.initOfferId === offer.id) >= 0) {
    //                 this.initTabId = "free";
    //             } else if (this.couponOffers.findIndex((offer) => this.initOfferId === offer.id) >= 0) {
    //                 this.initTabId = "discount";
    //             }
    //         }
    //     });
    // }
    //
    // ionViewWillEnter() {
    //     if (this.freeList && this.freeList.length > 0) this.freeList.first.wakeUp();
    //     if (this.couponList && this.couponList.length > 0) this.couponList.first.wakeUp();
    //     if (this.offerMap && this.offerMap.length > 0) this.offerMap.first.wakeUp();
    //     Log.trace(Log.Tag.OffersPage, "navigatedTo");
    // }
    //
    // ionViewWillLeave() {
    //     if (this.freeList && this.freeList.length > 0) this.freeList.first.sleep();
    //     if (this.couponList && this.couponList.length > 0) this.couponList.first.sleep();
    //     if (this.offerMap && this.offerMap.length > 0) this.offerMap.first.sleep();
    //     Log.trace(Log.Tag.OffersPage, "navigatingFrom");
    // }
    //
    // ngAfterViewInit(): void {
    // }
    //
    // ngOnDestroy(): void {
    //     if (this.ticketsSubscription) this.ticketsSubscription.unsubscribe();
    //     if (this.freeList && this.freeList.length > 0) this.freeList.first.sleep();
    //     if (this.couponList && this.couponList.length > 0) this.couponList.first.sleep();
    //     if (this.offerMap && this.offerMap.length > 0) this.offerMap.first.sleep();
    //     if (this.readySubscription) this.readySubscription.unsubscribe();
    //     if (this.resumeSubscription) this.resumeSubscription.unsubscribe();
    // }
    //
    // onUpdateSearchFilter(filter: OfferFilter) {
    //     if (filter && !deepEquals(filter, this.filter)) {
    //         this.filter = _.cloneDeep(filter);
    //         this.onWaiting(true);
    //         this.onWaitingSpinning(false);
    //         setTimeout(() => {
    //             this.reloadOffers();
    //             this.onWaiting(false);
    //         }, 1);
    //     }
    // }
    //
    // onSponsorTap() {
    //     if (this.sponsor) {
    //         if (this.api.offers_isShowSponsorPage()) {
    //             this.api.interaction(InteractionType.OpenSponsor, InteractionComponent.OffersPage, InteractionRefType.Sponsor, this.sponsor ? this.sponsor.id : null);
    //             if (this.freeList && this.freeList.length > 0) this.freeList.first.sleep();
    //             if (this.couponList && this.couponList.length > 0) this.couponList.first.sleep();
    //             if (this.offerMap && this.offerMap.length > 0) this.offerMap.first.sleep();
    //             this.nav.navPageSponsor(true);
    //         }
    //     }
    // }
    //
    // onWaiting(waiting: boolean) {
    //     this.waiting = waiting;
    //     this.cd.detectChanges();
    // }
    //
    // onWaitingSpinning(waitingSpinning: boolean) {
    //     this.waitingSpinning = waitingSpinning;
    //     this.cd.detectChanges();
    // }
    //
    // onFreeSelectionChange(index: number) {
    //     this.selectedFree = index;
    //     this.changedSelection = true;
    // }
    //
    // onCouponSelectionChange(index: number) {
    //     this.selectedCoupon = index;
    //     this.changedSelection = true;
    // }
    //
    // onNavSelectionChange(index: number) {
    //     Log.setDefaultLevel(Level.debug);
    //     Log.debug(Log.Tag.OffersPage, "CHANGE NAV: " + index);
    //     // figure out the currently displayed option in the previous nav, who the merchant is, and make sure in the next nav, an offer from the same merchant is selected
    //     if (this.selectedNav !== index) {
    //         const freeInfo = this.freeOffers && this.freeOffers.length > this.selectedFree ? this.freeOffers[this.selectedFree] : null;
    //         const couponInfo = this.couponOffers && this.couponOffers.length > this.selectedCoupon ? this.couponOffers[this.selectedCoupon] : null;
    //         if (this.freeList && this.freeList.length > 0) this.freeList.first.autoClose();
    //         if (this.couponList && this.couponList.length > 0) this.couponList.first.autoClose();
    //         if (this.changedSelection) {
    //             const freeCompanyId = freeInfo ? freeInfo.companyId : null;
    //             const couponCompanyId = couponInfo ? couponInfo.companyId : null;
    //             // if we've been scrolling around while switching between offer lists, sync up the selection
    //             if (freeCompanyId !== couponCompanyId) {
    //                 Log.debug(Log.Tag.OffersPage, "MISMATCH COMPANY: " + freeCompanyId + " !== " + couponCompanyId);
    //                 if (this.selectedNavId === "free" && this.getSelectedNavId(index) === "discount") {
    //                     const recommendId = this.findSameMerchantOfferId(this.couponOffers, freeCompanyId);
    //                     if (recommendId !== null) {
    //                         if (this.couponList && this.couponList.length > 0) this.couponList.first.autoGotoSelect(recommendId);
    //                     }
    //                 } else if (this.selectedNavId === "discount" && this.getSelectedNavId(index) === "free") {
    //                     const recommendId = this.findSameMerchantOfferId(this.freeOffers, couponCompanyId);
    //                     if (recommendId !== null) {
    //                         if (this.freeList && this.freeList.length > 0) this.freeList.first.autoGotoSelect(recommendId);
    //                     }
    //                 }
    //             }
    //         }
    //
    //         this.changedSelection = false;
    //         this.selectedNav = index;
    //
    //         if (this.selectedNavId === "free") {
    //             if (this.freeList && this.freeList.length > 0) this.freeList.first.wakeUp();
    //             if (this.couponList && this.couponList.length > 0) this.couponList.first.sleep();
    //             if (this.offerMap && this.offerMap.length > 0) this.offerMap.first.sleep();
    //         } else if (this.selectedNavId === "discount") {
    //             if (this.freeList && this.freeList.length > 0) this.freeList.first.sleep();
    //             if (this.couponList && this.couponList.length > 0) this.couponList.first.wakeUp();
    //             if (this.offerMap && this.offerMap.length > 0) this.offerMap.first.sleep();
    //         } else if (this.selectedNavId === "map") {
    //             if (this.freeList && this.freeList.length > 0) this.freeList.first.sleep();
    //             if (this.couponList && this.couponList.length > 0) this.couponList.first.sleep();
    //             if (this.offerMap && this.offerMap.length > 0) this.offerMap.first.wakeUp();
    //         }
    //
    //     }
    // }
    //
    // onShowOffer(action: OfferShowAction) {
    //     if (action.intermission) {
    //     } else {
    //         this.reloadOffers();
    //         this.autoGotoSelect(action.offerId).then(() => {
    //             if (action.open) {
    //                 this.autoSelectAndOpen(action.offerId);
    //             } else {
    //                 this.autoGotoSelect(action.offerId, action.duration);
    //             }
    //         });
    //     }
    // }
    //
    // onResetSearch() {
    // }
    //
    // private reloadOffers() {
    //     this.loadOffers();
    //     this.cd.detectChanges();
    // }
    //
    // private autoGotoSelect(offerId: number, tabSlideDuration: number = 500, autoSelectTab: boolean = true): Promise<void> {
    //     return new Promise((resolve, reject) => {
    //         if (this.freeOffers.findIndex((offer) => offerId === offer.id) >= 0) {
    //             Log.trace(Log.Tag.OffersPage, "GOTO FREE ----------------> " + offerId);
    //             if (this.freeList && this.freeList.length > 0) {
    //                 this.freeList.first.autoGotoSelect(offerId).then(() => {
    //                     this.changedSelection = true;
    //                     if (autoSelectTab) {
    //                         resolve();
    //                     } else {
    //                         resolve();
    //                     }
    //                 });
    //             }
    //         } else if (this.couponOffers.findIndex((offer) => offerId === offer.id) >= 0) {
    //             Log.trace(Log.Tag.OffersPage, "GOTO COUPON ----------------> " + offerId);
    //             if (this.couponList && this.couponList.length > 0) {
    //                 this.couponList.first.autoGotoSelect(offerId).then(() => {
    //                     this.changedSelection = true;
    //                     if (autoSelectTab) {
    //                         resolve();
    //                     } else {
    //                         resolve();
    //                     }
    //                 });
    //             }
    //         } else {
    //             resolve();
    //         }
    //     });
    // }
    //
    // private autoGotoSelectAndOpen(offerId: number) {
    //     if (this.freeOffers.findIndex((offer) => offerId === offer.id) >= 0) {
    //         this.changedSelection = false;
    //         if (this.freeList && this.freeList.length > 0) this.freeList.first.autoGotoSelectAndOpen(offerId);
    //     } else if (this.couponOffers.findIndex((offer) => offerId === offer.id) >= 0) {
    //         this.changedSelection = false;
    //         if (this.couponList && this.couponList.length > 0) this.couponList.first.autoGotoSelectAndOpen(offerId);
    //     }
    // }
    //
    // private autoSelectAndOpen(offerId: number) {
    //     if (this.freeOffers.findIndex((offer) => offerId === offer.id) >= 0) {
    //         if (this.freeList && this.freeList.length > 0) {
    //             this.freeList.first.autoSlideSelectAndOpen(offerId);
    //             this.changedSelection = true;
    //         }
    //     } else if (this.couponOffers.findIndex((offer) => offerId === offer.id) >= 0) {
    //         if (this.couponList && this.couponList.length > 0) {
    //             this.couponList.first.autoSlideSelectAndOpen(offerId);
    //             this.changedSelection = true;
    //         }
    //     }
    // }
    //
    // // private loadOffers(): Promise<void> {
    // //     return new Promise((resolve, reject) => {
    // //         const errorHandler = (error) => {
    // //             reject(error);
    // //         };
    // //
    // //         let readyCount = 0;
    // //         const requiredCount = this.tabs.length;
    // //         const incReady = () => {
    // //             readyCount++;
    // //             if (readyCount === requiredCount) {
    // //                 resolve();
    // //             }
    // //         };
    // //
    // //         this.freeList.changes.pipe(take(1)).subscribe((changes) => {
    // //             if (this.freeList && this.freeList.length > 0) {
    // //                 this.freeList.first.layoutReady().pipe(filter((v) => v), take(1)).subscribe(() => {
    // //                     incReady();
    // //                 });
    // //             }
    // //         });
    // //         this.couponList.changes.pipe(take(1)).subscribe((changes) => {
    // //             if (this.couponList && this.couponList.length > 0) {
    // //                 this.couponList.first.layoutReady().pipe(filter((v) => v), take(1)).subscribe(() => {
    // //                     incReady();
    // //                 });
    // //             }
    // //         });
    // //     });
    // // }
    //
    // private findSameMerchantOfferId(offers: Array<OfferInfo>, companyId: number): number {
    //     let outOfferId = null;
    //     if (companyId) {
    //         offers.forEach((offer, index) => {
    //             if (offer.companyId === companyId && outOfferId === null) {
    //                 outOfferId = offer.id;
    //             }
    //         });
    //     }
    //     return outOfferId;
    // }
    //
    // private prepMirrorOffer() {
    //     // make sure that the free/coupon offer selection is prepped so that if there's a toggle, the images are already loaded and ready to display smoothly
    //     const freeInfo = this.freeOffers && this.freeOffers.length > this.selectedFree ? this.freeOffers[this.selectedFree] : null;
    //     const couponInfo = this.couponOffers && this.couponOffers.length > this.selectedCoupon ? this.couponOffers[this.selectedCoupon] : null;
    //     const freeCompanyId = freeInfo ? freeInfo.companyId : null;
    //     const couponCompanyId = couponInfo ? couponInfo.companyId : null;
    //     // if we've been scrolling around while switching between offer lists, sync up the selection
    //     if (freeCompanyId !== couponCompanyId) {
    //         Log.debug(Log.Tag.OffersPage, "PREP MISMATCH OFFER: " + freeCompanyId + " !== " + couponCompanyId);
    //         if (this.selectedNavId === "free") {
    //             const recommendId = this.findSameMerchantOfferId(this.couponOffers, freeCompanyId);
    //             if (recommendId !== null) {
    //                 if (this.couponList && this.couponList.length > 0) this.couponList.first.prepareImageView(recommendId);
    //             }
    //         } else if (this.selectedNavId === "discount") {
    //             const recommendId = this.findSameMerchantOfferId(this.freeOffers, couponCompanyId);
    //             if (recommendId !== null) {
    //                 if (this.freeList && this.freeList.length > 0) this.freeList.first.prepareImageView(recommendId);
    //             }
    //         }
    //     }
    // }
    //
    // private getSelectedNavId(tab: number): string {
    //     return "offers";
    // }
    // private getSelectedNavIndex(id: string): number {
    //     let navIndex: number = null;
    //     return navIndex;
    // }
    //
    // private loadOffers() {
    //     this.numFavorites = 0;
    //     if (this.settings.combinedOffersTab) {
    //         this.freeOffers = this.api.offers_loadOffers(true, this.filter, "all");
    //         this.couponOffers = [];
    //         if (this.settings.gamificationFavoriteMode) {
    //             this.couponOffers = this.api.offers_loadOffers(true, this.filter, "favorites");
    //             this.numFavorites = this.couponOffers.length;
    //         }
    //     } else {
    //         this.freeOffers = this.api.offers_loadOffers(true, this.filter, "free");
    //         this.couponOffers = this.api.offers_loadOffers(true, this.filter, "discount");
    //     }
    //     this.mapOffers = [];
    //     this.allOffers = [];
    //     if (this.freeOffers) this.freeOffers.forEach(offer => this.allOffers.push(offer));
    //     if (this.couponOffers) this.couponOffers.forEach(offer => this.allOffers.push(offer));
    //     this.allOffers.forEach((o) => {
    //         if (o.addresses && o.addresses.length > 0 && !o.sample) this.mapOffers.push(o);
    //         // if (o.nextAvailableDate) this.notify.scheduleBouncebackNotification(o);
    //     });
    //     const numTotalOffers = this.api.offers_totalSearchOffers();
    //     this.allowFiltering = this.settings.allowFiltering && this.settings.filteringMinOffers <= numTotalOffers;
    //
    //     if (this.settings.showShareCoupon && !this.isActiveSearch) {
    //         this.freeOffers.push({
    //             id: -1,
    //             free: false,
    //             bounceback: false,
    //             revealCost: 0,
    //             revealed: true,
    //             favoriteCost: 0,
    //             favorite: true,
    //             repeatUnlockCost: 0,
    //             repeatUnlocked: true,
    //             seenDate: toDateStr(momentNow().add(-1, "days")),
    //             sample: false,
    //             name: "Expecting more offers?",
    //             imageBannerText: "Don't worry, more offers are coming!",
    //             terms: "More and more offers will be coming to your area soon. Please help by SHARING the WhutsFree app with your friends!",
    //             expirationDate: toDateStr(momentNow().add(100, "days")),
    //             imageUrl: "images/redeemed_sunburst.png",
    //             companyId: -1,
    //             companyName: "WhutsFree",
    //             companyLogoUrl: "images/logo_transparent.png",
    //             companyWebUrl: "",
    //             reviewUrl: "",
    //             addresses: []
    //         });
    //     }
    //     if (this.settings.showBusinessCoupon && !this.isActiveSearch) {
    //         this.freeOffers.push({
    //             id: -2,
    //             free: true,
    //             revealCost: 0,
    //             revealed: true,
    //             favoriteCost: 0,
    //             favorite: true,
    //             bounceback: false,
    //             repeatUnlockCost: 0,
    //             repeatUnlocked: true,
    //             seenDate: toDateStr(momentNow().add(-1, "days")),
    //             sample: false,
    //             name: "BUSINESS OWNERS",
    //             imageBannerText: "Want more customers? Start your FREE offer!",
    //             terms: "Contact us today to provide a free offer. It won't cost you anything and your customers will love you even more!",
    //             expirationDate: toDateStr(momentNow().add(100, "days")),
    //             imageUrl: "images/redeemed_sunburst.png",
    //             companyId: -1,
    //             companyName: "WhutsFree",
    //             companyLogoUrl: "images/logo_transparent.png",
    //             companyWebUrl: "",
    //             reviewUrl: "",
    //             addresses: []
    //         });
    //     }
    //     if (this.isActiveSearch && this.freeOffers.length === 0) {
    //         this.freeOffers.push({
    //             id: -3,
    //             free: true,
    //             bounceback: false,
    //             revealCost: 0,
    //             revealed: true,
    //             favoriteCost: 0,
    //             favorite: true,
    //             repeatUnlockCost: 0,
    //             repeatUnlocked: true,
    //             seenDate: toDateStr(momentNow().add(-1, "days")),
    //             sample: false,
    //             name: "NO FREE MATCHES",
    //             imageBannerText: "We didn't find any FREE offers matching your search...",
    //             terms: "Your search didn't find any FREE offers. To reset your search, tap on the Reset Search button below.",
    //             expirationDate: toDateStr(momentNow().add(100, "days")),
    //             imageUrl: "images/search_not_found.png",
    //             companyId: -1,
    //             companyName: "WhutsFree",
    //             companyLogoUrl: "images/logo_transparent.png",
    //             companyWebUrl: "",
    //             reviewUrl: "",
    //             addresses: []
    //         });
    //     }
    //     if (this.settings.gamificationFavoriteMode && this.couponOffers.length === 0) {
    //         this.couponOffers.push({
    //             id: -4,
    //             free: false,
    //             bounceback: true,
    //             revealCost: 0,
    //             revealed: true,
    //             favoriteCost: 0,
    //             favorite: true,
    //             repeatUnlockCost: 0,
    //             repeatUnlocked: true,
    //             seenDate: toDateStr(momentNow().add(-1, "days")),
    //             sample: false,
    //             name: "NO FAVORITES YET",
    //             imageBannerText: "Start adding favorites",
    //             terms: "Visit the Discover tab to browse the available offers. You can 'Favorite' unlocked offers using the 'Heart' button. Return to the 'Favorites' tab to see your favorite offers.",
    //             expirationDate: toDateStr(momentNow().add(100, "days")),
    //             imageUrl: "images/search_not_found.png",
    //             companyId: -1,
    //             companyName: "WhutsFree",
    //             companyLogoUrl: "images/logo_transparent.png",
    //             companyWebUrl: "",
    //             reviewUrl: "",
    //             addresses: []
    //         });
    //     } else if (this.isActiveSearch && this.couponOffers.length === 0) {
    //         this.couponOffers.push({
    //             id: -3,
    //             free: false,
    //             bounceback: true,
    //             revealCost: 0,
    //             revealed: true,
    //             favoriteCost: 0,
    //             favorite: true,
    //             repeatUnlockCost: 0,
    //             repeatUnlocked: true,
    //             seenDate: toDateStr(momentNow().add(-1, "days")),
    //             sample: false,
    //             name: "NO COUPON MATCHES",
    //             imageBannerText: "We didn't find any coupons matching your search...",
    //             terms: "Your search didn't find any discount coupons. To clear your search text, tap on Reset Search below.",
    //             expirationDate: toDateStr(momentNow().add(100, "days")),
    //             imageUrl: "images/search_not_found.png",
    //             companyId: -1,
    //             companyName: "WhutsFree",
    //             companyLogoUrl: "images/logo_transparent.png",
    //             companyWebUrl: "",
    //             reviewUrl: "",
    //             addresses: []
    //         });
    //     }
    // }
}
